import { useEffect, useRef } from "react";

const WORDS = ["acid", "memory"];
const HOLD_MS = 2000;

export const useHiddenTriggers = ({ onAcid, onMemory }) => {
  const typed = useRef("");
  const taps = useRef([]);
  const hold = useRef(null);
  const handlers = useRef({});
  handlers.current = { acid: onAcid, memory: onMemory };

  useEffect(() => {
    const onKey = (e) => {
      if (e.key.length !== 1 || document.querySelector('[role="dialog"]')) return;
      typed.current = (typed.current + e.key.toLowerCase()).slice(-6);
      const word = WORDS.find((w) => typed.current.endsWith(w));
      if (word) {
        typed.current = "";
        handlers.current[word]();
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  const onTitleClick = () => {
    const now = Date.now();
    taps.current = [...taps.current.filter((t) => now - t < 2000), now];
    if (taps.current.length >= 5) {
      taps.current = [];
      handlers.current.acid();
    }
  };
  const startHold = () => {
    clearTimeout(hold.current);
    hold.current = setTimeout(() => { taps.current = []; handlers.current.memory(); }, HOLD_MS);
  };
  const endHold = () => clearTimeout(hold.current);

  return { titleProps: { onClick: onTitleClick, onPointerDown: startHold, onPointerUp: endHold, onPointerLeave: endHold, onPointerCancel: endHold } };
};
